export default __webpack_public_path__ + "/dist/images/logo12.c0d97a097c763159fdc0fd9e9631415d.jpg";